export type SkeletonSize = "xs" | "sm" | "base" | "lg" | "xl";
export type SkeletonWidth = "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | string;
export type SkeletonSpacing = "sm" | "md" | "lg";
export type SkeletonGap = "sm" | "md" | "lg";
export type SkeletonAlign = "start" | "center";

// Animation constants
export const SKELETON_ANIMATION_CLASSES = {
  default: "animate-pulse",
  slow: "animate-pulse [animation-duration:2s]",
  fast: "animate-pulse [animation-duration:0.5s]",
  none: "",
} as const;

export const SKELETON_BASE_CLASS = `bg-muted ${SKELETON_ANIMATION_CLASSES.default}`;

export const SKELETON_TEXT_SIZES: Record<SkeletonSize, string> = {
  xs: "h-3",
  sm: "h-4", 
  base: "h-5",
  lg: "h-6",
  xl: "h-8",
};

export const SKELETON_TEXT_WIDTHS: Record<Exclude<SkeletonWidth, string>, string> = {
  xs: "w-12",
  sm: "w-16", 
  md: "w-24",
  lg: "w-32",
  xl: "w-40",
  "2xl": "w-48",
};

export const SKELETON_SPACING_CLASSES: Record<SkeletonSpacing, string> = {
  sm: "space-y-1",
  md: "space-y-2", 
  lg: "space-y-3",
};

export const SKELETON_GAP_CLASSES: Record<SkeletonGap, string> = {
  sm: "gap-2",
  md: "gap-3",
  lg: "gap-4",
};

export const SKELETON_ALIGN_CLASSES: Record<SkeletonAlign, string> = {
  start: "items-start",
  center: "items-center",
}; 